import Supercluster from "supercluster";
import { useCallback, useEffect, useMemo, useReducer } from "react";

import { useMapViewport } from "./useMapViewport";

export function useSupercluster(geojson, superclusterOptions) {
  const clusterer = useMemo(
    () => new Supercluster(superclusterOptions),
    [superclusterOptions]
  );

  // Bump a version whenever data is (re)loaded so the clusters memo recomputes.
  const [version, dataWasUpdated] = useReducer(x => x + 1, 0);

  useEffect(() => {
    clusterer.load(geojson.features);
    dataWasUpdated();
  }, [clusterer, geojson]);

  const { bbox, zoom } = useMapViewport({ padding: 100 });

  const clusters = useMemo(() => {
    // getClusters throws before any data is loaded (version === 0).
    if (!clusterer || version === 0) {
      return [];
    }
    return clusterer.getClusters(bbox, zoom);
  }, [version, clusterer, bbox, zoom]);

  const getLeaves = useCallback(
    clusterId => clusterer.getLeaves(clusterId, Infinity),
    [clusterer]
  );

  const getClusterExpansionZoom = useCallback(
    clusterId => clusterer.getClusterExpansionZoom(clusterId),
    [clusterer]
  );

  return { clusters, getLeaves, getClusterExpansionZoom };
}
